import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_table, {
      scroll: _ctx.scroll,
      "data-source": _ctx.tableData,
      columns: _ctx.columns,
      "row-key": (record) => record.templateId,
      pagination: false
    }, {
      action: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.delTemplateAction(record.templateId))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["scroll", "data-source", "columns", "row-key"])
  ]))
}